import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function AboutBlkn() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}